import { NgModule } from '@angular/core';
import { ActionHandlingDispatcher } from './action-dispatch-handler';
import { ActionDispatcher } from './action-dispatcher';
import { FallbackActionDispatcher } from './fallback-action-dispatcher';
import { ActionService } from './action.service';

/**
 *
 *
 * You can add action handlers to the chain behind `ActionService`
 * by binding them to the multiprovider for
 * [DI token](https://angular.io/guide/glossary#di-token) `ACTION_HANDLERS`
 */
@NgModule({
  providers: [
    ActionService,
    { provide: ActionDispatcher, useClass: ActionHandlingDispatcher },
    FallbackActionDispatcher,
  ],
})
export class ActionsModule {}
